export enum ContinentId {
  Asia = '6255147',
  Europe = '6255148',
  Oceania = '6255151',
  NorthAmerica = '6255149',
  Africa = '6255146',
  SouthAmerica = '6255150',
  Antarctica = '6255152',
}

export enum CountryOrRegionId {
  China = '1814991',
  HongKong = '1819730',
  /** 独立语言 */
  TaiWan = '1668284',
  Macao = '1821275',
  Korea = '1835841',
  // 东南亚, 菲律宾、新加坡、马来西亚、越南、泰国、印度尼西亚、缅甸、柬埔寨、老挝、文莱、东帝汶
  /** 独立语言 */
  Thailand = '1605651',
  /** 独立语言 */
  Indonesia = '1643084',
  Malaysia = '1733045',
  Singapore = '1880251',
  Vietnam = '1562822',
  Philippines = '1694008',
  Cambodia = '1831722',
  Laos = '1655842',
  Myanmar = '1327865',
  Brunei = '1820814',
  EastTimor = '1966436',

  // 日本
  /** 独立语言 */
  Japan = '1861060',
  // 欧美
  /** 独立语言 */
  German = '2921044',
  Spain = '2510769',
  /** 独立语言 */
  France = '3017382',
  UnitedKingdom = '2635167',
  // 南美
  /** 独立语言 */
  Brazil = '3469034',
  Portugal = '2264397',
  // 北美
  UnitedStates = '6252001',
  Canada = '6251999',
  Mexico = '3996063',

  // 排除
  // 俄罗斯
  Russia = '2017370',
  // 白俄罗斯
  Belarus = '630336',
  // 摩尔多瓦
  Moldova = '617790',
  // 北马其顿
  Macedonia = '718075',
  // 塞尔维亚
  Serbia = '6290252',
  // 黑山
  Montenegro = '3194884',
  // 巴哈马
  Bahamas = '3572887',

  Bangladesh = '1210997',
  Tajikistan = '1220409',
  SolomonIslands = '2103350',
  Vanuatu = '2134431',

  /** 印度 */
  India = '1269750',
  /** 伊朗 */
  Iran = '130758',
  /** 伊拉克 */
  Iraq = '99237',
  /** 叙利亚 */
  Syrian = '163843',
  /** 阿富汗 */
  Afghanistan = '1149361',
  /** 马里 */
  Mali = '2453866',
  /** 津巴布韦 */
  Zimbabwe = '878675',
  /** 安哥拉 */
  Angola = '3351879',
  /** 刚果共和国 */
  Congo = '2260494',
  /** 刚果民主共和国 */
  DemocraticCongo = '203312',
  /** 喀麦隆 */
  Cameroon = '2233387',
  /** 肯尼亚 */
  Kenya = '192950',
  /** 也门 */
  Yemen = '69543',
  /** 利比亚 */
  Libya = '2215636',
  /** 阿尔及利亚 */
  Algeria = '2589581',
  /** 突尼斯 */
  Tunisia = '2464461',
  /** 格鲁吉亚 */
  Georgia = '614540',
  /** 阿塞拜疆 */
  Azerbaijan = '587116',
  /** 亚美尼亚 */
  Armenia = '174982',
  /** 摩洛哥 */
  Morocco = '2542007',
}
